// ** React Imports
import { useEffect, useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'

// ** Custom Components
import CustomChip from 'src/materio/@core/components/mui/chip'

// ** Types
import { ThemeColor } from 'src/materio/@core/layouts/types'

import { MissingData, LeadScreenStore, ViewType, HotLeadStore, LeadListStore } from "src/stores/LeadStore";
import { red } from '@mui/material/colors'
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import ThreeDRotation from '@mui/icons-material/ThreeDRotation';
import { inherits } from 'util'
import LocalFireDepartmentTwoTone from '@mui/icons-material/LocalFireDepartmentTwoTone';
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import { client } from '../../utils/axios-client'
import { getLeadEndpoint, leadEndpoints } from '../../configs/endpoints'
import { ProblemDetails } from '../../types/ApiErrorResponse'
import _ from 'lodash'


interface Props {
    leadId: string,
    hotLead: boolean,
}

const HotLeadToggleIcon = ({ leadId, hotLead }: Props) => {

    const [toggleValue, setToggleValue] = useState(false)
    const [iconColor, setIconColor] = useState('')
    const [toolTipText, setToolTipText] = useState('')
    const hotLeadStore = HotLeadStore.useState(s => s.record);

    useEffect(() => {
        if (hotLead) {
            setToolTipText('Is a Hot Lead, click to change');
            setIconColor('FireBrick');
            setToggleValue(true);
        }
        else {
            setToolTipText('Is NOT a Hot Lead, click to change');
            setIconColor('');
            setToggleValue(false);
        }
    }, [hotLead])

    const submitChange = async (toggleValue: boolean) => {
        HotLeadStore.update(s => { s.record.leadId = leadId })
        HotLeadStore.update(s => { s.record.hotLead = toggleValue })

        await client.post(leadEndpoints.updatehotleadendpoint, { leadId: leadId, hotLead: toggleValue })
            .then(async (response) => {
                //Handle response as needed

                const updatedLeadResposne = await client.get(getLeadEndpoint.replace("{id}", leadId));

                LeadListStore.update(s => {
                    const list = _.cloneDeep(s.list);
                    const leadIndex = list.items.findIndex(s => s.id == leadId);
                    const existingLead = list.items[leadIndex];
                    list.items[leadIndex] = { ...existingLead, ...updatedLeadResposne.data };
                    s.list = list;
                });

            }).catch((err: ProblemDetails) => {
                if (err.errors) {
                    for (const [key, value] of Object.entries(err.errors)) {
                        var errorMessage = '';

                        value.forEach((message) => {
                            message += message + '\\'
                        });
                    }
                }
            });
        
    }

    const changeIcon = () => {
        if (iconColor == 'FireBrick') {
            setToolTipText('Is NOT a Hot Lead, click to change');
            setIconColor('');
            setToggleValue(false);
        }
        else {
            setToolTipText('Is a Hot Lead, click to change');
            setIconColor('FireBrick');
            setToggleValue(true);
        }

        submitChange(toggleValue);
        
    }

    

    
    return (
        <Box>
            <Tooltip title={toolTipText}>
                <IconButton onClick={changeIcon}>
                    <LocalFireDepartmentTwoTone sx={{ color: iconColor }} />
                </IconButton>
            </Tooltip>
        </Box>
    )

}

export { HotLeadToggleIcon }
export default HotLeadToggleIcon